import { render, staticRenderFns } from "./productLineCapacityTable.vue?vue&type=template&id=c065e39c&scoped=true"
import script from "./productLineCapacityTable.vue?vue&type=script&lang=js"
export * from "./productLineCapacityTable.vue?vue&type=script&lang=js"
import style0 from "./productLineCapacityTable.vue?vue&type=style&index=0&id=c065e39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c065e39c",
  null
  
)

export default component.exports